export enum HcoTabIndex {
  OVERVIEW = 'overview',
  STRUCTURE = 'structure',
  SALES = 'sales',
  SCIENTIFIC_INFORMATION = 'scientific-information',
  ACCOUNT_PLAN = 'account-plan',
  SEGMENTATION = 'segmentation',
  INSIGHTS = 'insights',
  HCO_ENGAGEMENT = 'hco-engagement',
  HCO_FEEDBACK = 'hco-feedback',
}

export type HcoSection = `${HcoTabIndex}`;

export type HcoTab = {
  label: string;
  param: HcoTabIndex;
  isTabDisabled: boolean;
};

export const HCO_TABS: HcoTab[] = [
  { label: 'main.hcoOverview.tabMenu.overview', param: HcoTabIndex.OVERVIEW, isTabDisabled: false },
  {
    label: 'main.hcoOverview.tabMenu.structure',
    param: HcoTabIndex.STRUCTURE,
    isTabDisabled: false,
  },
  {
    label: 'main.hcoOverview.tabMenu.sales',
    param: HcoTabIndex.SALES,
    isTabDisabled: true,
  },
  {
    label: 'main.hcoOverview.tabMenu.hcoEngagement',
    param: HcoTabIndex.HCO_ENGAGEMENT,
    isTabDisabled: false,
  },
  {
    label: 'main.hcoOverview.tabMenu.scientificInformation',
    param: HcoTabIndex.SCIENTIFIC_INFORMATION,
    isTabDisabled: true,
  },
  {
    label: 'main.hcoOverview.tabMenu.accountPlan',
    param: HcoTabIndex.ACCOUNT_PLAN,
    isTabDisabled: true,
  },
  {
    label: 'main.hcoOverview.tabMenu.segmentation',
    param: HcoTabIndex.SEGMENTATION,
    isTabDisabled: true,
  },
  {
    label: 'main.hcoOverview.tabMenu.insights',
    param: HcoTabIndex.INSIGHTS,
    isTabDisabled: true,
  },
  {
    label: 'main.hcoOverview.tabMenu.hcoFeedback',
    param: HcoTabIndex.HCO_FEEDBACK,
    isTabDisabled: true,
  },
];
